import type { CollectionHistoryJSONObject, CollectionSearchResults } from '@ikegps/core-api';
import { type CollectionModel, IkeRestObjects } from '@ikegps/core-shared';
import { Services } from '../services';

export class CollectionStore {
	has(revision: string): boolean {
		const rest = Services.Department.rest;
		const ikeCollection = rest.Collection.getModel(revision);
		if (!ikeCollection.hasFetched) {
			return false;
		}
		return ikeCollection.hasFetched;
	}

	get(revision: string): CollectionModel | null {
		if (!revision) {
			return null;
		}
		const rest = Services.Department.rest;
		const collection = rest.Collection.getModel(revision)?.value;
		if (collection == null) {
			return null;
		}
		return collection;
	}

	async getHistory(collectionUuid: string): Promise<CollectionHistoryJSONObject[]> {
		const query = Services.Department.rest.query(IkeRestObjects.CollectionHistory);
		query.where.uuid = collectionUuid;
		return query.findAll();
	}

	async fetch(revision: string): Promise<CollectionModel | null> {
		const rest = Services.Department.rest;
		return await rest.Collection.getModel(revision).fetch();
	}

	async search(text: string): Promise<CollectionSearchResults[]> {
		const currentDepartment = Services.Department.current;
		if (currentDepartment == null) {
			return Promise.resolve([]);
		}

		const data = {
			type: 'collection' as const,
			text,
		};

		const response = await Services.Department.rest.Collection.search(data);
		return response.results;
	}
}
